import { createApp } from "vue";
import { createPinia, storeToRefs } from "pinia";
import App from "./App.vue";
import { router } from "./router";
import "./assets/scss/app.scss";
import "bootstrap";
import axios, { AxiosInstance } from "axios";
import Vue3Toasity, { ToastContainerOptions } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { useClientStore } from "@/store/ClientStore";
import VueApexCharts from "vue3-apexcharts";
import VueObserveVisibility from "vue3-observe-visibility";

const store = createPinia();

export const impalaApi: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // baseURL: "https://xc63n71yab.execute-api.eu-central-1.amazonaws.com",
});

//https://blog.impala-research.com/api/
export const blogApi: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BLOG_BASE_URL,
});

impalaApi.interceptors.request.use(
  async (config) => {
    config.headers.Authorization = localStorage.getItem("token");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const app = createApp(App)
  .use(store)
  .use(router)
  .use(Vue3Toasity, {
    autoClose: 3000,
  } as ToastContainerOptions)
  .use(VueApexCharts)
  .use(VueObserveVisibility);

export function refreshToken(): void {
  const token = localStorage.getItem("token");
  if (token !== undefined) {
    impalaApi
      .post("/auth/refresh", { token })
      .then((response) => {
        const newToken = response.data;
        localStorage.setItem("token", newToken);
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

// Refresh token every 5 minutes
setInterval(refreshToken, 5 * 60 * 1000);

app.mount("#app");

const clientStore = useClientStore();
const { pageLoading } = storeToRefs(clientStore);
router.beforeEach((to, from, next) => {
  pageLoading.value = true;
  const auth = localStorage.getItem("token");
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (auth) {
      next();
      return;
    }
    next({ name: "SignIn" });
  } else if (to.matched.some((record) => record.meta.requiresAuth === false)) {
    if (!auth) {
      next();
      return;
    }
    if (clientStore.isTestsEnabled) {
      next({ name: "Medical Tests" });
      return;
    }
    next({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore //
      name: "Secured",
      query: { isMedical: clientStore.isTestsEnabled },
      // query: { isMedical: clientStore.isTestsEnabled },
    });
  } else {
    next();
  }
});

router.afterEach((to) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title as string;
  }
  pageLoading.value = false;
});
